import script from "./MediaLibraryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaLibraryDetail.vue?vue&type=script&setup=true&lang=js"

import "./MediaLibraryDetail.vue?vue&type=style&index=0&id=3a00e082&lang=scss"

const __exports__ = script;

export default __exports__